"use client";
import t, { useRef as N } from "react";
import $ from "./index.es48.js";
import "./index.es16.js";
import "./index.es17.js";
import "./index.es18.js";
import "./index.es19.js";
import "./index.es20.js";
import "./index.es21.js";
import "./index.es22.js";
import "./index.es23.js";
import k from "./index.es24.js";
import "./index.es25.js";
import "./index.es26.js";
import "./index.es27.js";
import "./index.es28.js";
import "./index.es29.js";
import v from "./index.es30.js";
import "./index.es31.js";
import "./index.es32.js";
import "./index.es33.js";
import "./index.es34.js";
import "./index.es35.js";
import "./index.es36.js";
import "./index.es37.js";
import "./index.es38.js";
import y from "./index.es49.js";
import a from "./index.es5.js";
import R from "./index.es50.js";
const h = ({
  slug: n,
  ingress: p,
  sections: r,
  title: s,
  displayTitle: c,
  mainPoints: m,
  richtextSections: l,
  introduction: o,
  createdAt: d,
  updatedAt: f,
  publishedAt: E,
  hash: b
}) => {
  const i = N(null);
  y(i, b);
  const u = o ? o.content || "" : p, g = o?.tooltips || [];
  return /* @__PURE__ */ t.createElement("div", { ref: i }, /* @__PURE__ */ t.createElement("div", { className: "bl-container bl-container--small" }, /* @__PURE__ */ t.createElement(v, null, c || s), /* @__PURE__ */ t.createElement(
    k,
    {
      className: "stat-larger bl-p-b-4",
      content: u,
      keyContext: `statistics-page-${n}-intro`,
      tooltips: g
    }
  )), !!m && m.length > 0 && /* @__PURE__ */ t.createElement("div", { className: "bl-container bl-container--small" }, /* @__PURE__ */ t.createElement($, { points: m })), /* @__PURE__ */ t.createElement("div", { className: "bl-container bl-container--small" }, /* @__PURE__ */ t.createElement(
    R,
    {
      className: "bl-p-b-5",
      sections: r,
      richtextSections: l
    }
  )), /* @__PURE__ */ t.createElement(t.Fragment, null, r.map((e) => /* @__PURE__ */ t.createElement(a, { ...e, key: `statistics-section-${e?.id}` }))), l.map((e) => /* @__PURE__ */ t.createElement(
    a,
    {
      key: `richtext-section-${e.id}`,
      ingress: e.content,
      introduction: {
        content: e.content,
        tooltips: e.tooltips,
        id: e.id
      },
      displayTitle: e.title,
      slug: `richtext-${e.id}`,
      components: [],
      id: `richtext-${e.id}`,
      createdAt: d,
      updatedAt: f,
      publishedAt: E
    }
  )));
};
export {
  h as default
};
//# sourceMappingURL=index.es4.js.map
